import Vue from 'vue'
import Router from 'vue-router'
import jsCookie from 'js-cookie'
import { ensureLogin, toLogin, tracker, setCookie, isLeYou } from '@/utils/utils'
import { SUPPORTBUZZTYPE, BUZZTYPE } from '@/utils/constants'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: 'platform',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/index.vue'),
    },
    {
      path: '/ly',
      name: 'leYouHome',
      component: () => import('@/views/LeYouHome/index.vue'),
    },
  ]
})
router.beforeEach(async (to, from, next) => {
  ensureLogin()
  const buzzTypeNum = (jsCookie.get('buzzType') || '')* 1
  const buzzType = BUZZTYPE[buzzTypeNum]
  if (!SUPPORTBUZZTYPE.includes(buzzTypeNum)) {
    toLogin()
  } else {
    const json = await store.dispatch('checkPortalLogin')
    if (json.code * 1 === 1) {
      if (buzzType === 'pop') {
        // 旧数据上报
        tracker(147, 289073)
        // 热力图统计埋点数据上报
        tracker(116, 121013119)
      } else if (buzzType === 'partner') {
        if (!isLeYou) {
          await store.dispatch('doPartnerLogin')
        }
        // 旧数据上报
        tracker(147, 289086)
        // 热力图统计埋点数据上报
        tracker(116, 121013122)
      } else if (buzzType === 'brand') {
        // 旧数据上报
        tracker(147, 121013047)
        // 热力图统计埋点数据上报
        tracker(116, 121013121)
      } else if (buzzType === 'czj') {
        setCookie('czjbusiness', { bid: jsCookie.get('buzzId') || '', buzzId: jsCookie.get('buzzId') || '', token: ''})
        tracker(147, 289118)
      } else if (buzzType === 'yuer') {
        setCookie('czjbusiness', { bid: jsCookie.get('buzzId') || '', buzzId: jsCookie.get('buzzId') || '', token: ''})
        tracker(147, 289117)
      }
      next()
    } else if (json.code * 1 ===3 || json.code * 1 ===4) {
      toLogin()
      return
    }
  }
})
export default router
